module.exports = __webpack_public_path__ + "6c118b2f3163a87d07f183e1d80b20f9.svg";